import { Button } from '@/components/ui/button';

/** Shown when the app cannot even load its runtime config (GET /api/config). */
export function BootError({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : String(error);
  return (
    <main className="grid min-h-svh place-items-center p-6">
      <div role="alert" className="max-w-md space-y-3 text-center">
        <h1 className="text-lg font-semibold">The backoffice could not start</h1>
        <p className="text-sm text-muted-foreground">Loading the runtime configuration failed: {message}</p>
        <Button onClick={() => window.location.reload()}>Try again</Button>
      </div>
    </main>
  );
}
